import { render, staticRenderFns } from "./GoliveTitle.vue?vue&type=template&id=1483c0c6&"
import script from "./GoliveTitle.vue?vue&type=script&lang=js&"
export * from "./GoliveTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports